export default "__VITE_ASSET__5fdce3f7__"